document.addEventListener('DOMContentLoaded', function () {
  // add title to images
  const images = document.querySelectorAll("img");
  images.forEach((image) => {
    if (image.alt) {
      image.setAttribute("title", image.alt);
    }
  });
    // remove circling links
    let urls = document.querySelectorAll(`a`);
    if (urls.length) {
      urls.forEach((item) => {
        if (window.location.href === item.href) {
          if (!item.href.includes("#")) {
            item.removeAttribute("href");
            item.setAttribute("href", "#");
          }
        }
      });
    }
});
//import "./popup";
//import "./google-map";
//import "./main.min.js";

let requestButton = document.querySelectorAll(".modal-request-btn");

if(requestButton.length > 0) {
  requestButton.forEach(item => {
    item.addEventListener("click", function() {
      document.body.classList.toggle("overflow");
      document.querySelector("#modal-request").classList.add('modal__active');
    })
  })
};

const LogoUrls = document.querySelectorAll( '.header__logo' );

if ( LogoUrls.length ) {
	LogoUrls.forEach( ( item ) => {
		if ( window.location.href === item.href) {
			item.removeAttribute( 'href' );
			item.setAttribute( 'href', '#' );
		}
	} );
}

document.querySelector('.menu__burger').addEventListener('click', function() {
  document.body.classList.remove('stop-scrolling', 'overflow');
});